import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

export const useAddToCartPixel = (item: ICartProduct | IProduct, quantity: number) => {
  if (!window.fbq) return;

  window.fbq('track', 'AddToCart', {
    content_name: item.title,
    content_ids: [item.product_id],
    content_type: 'product',
    value: item.price * quantity,
    currency: 'BRL',
    quantity,
  });
};
